import { makeStyles } from '@material-ui/core/styles'
import { VIDEO_VISIT_REARRANGEMENT } from 'constants/breakpoints'

const useStyles = makeStyles((theme) => ({
  actions: {
    position: 'absolute',
    display: 'flex',
    flexFlow: 'column nowrap',
    bottom: '0.2em',
    right: '0.2em',
    [theme.breakpoints.up(VIDEO_VISIT_REARRANGEMENT)]: {
      marginBottom: '8px',
      marginRight: '8px',
    },
    [theme.breakpoints.down(VIDEO_VISIT_REARRANGEMENT)]: {
      flexDirection: 'row',
      /* for buttons */
      bottom: '-4.7em',
      right: '50%',
      transform: 'translateX(50%)',
    },
  },
}))

export default useStyles
